import { httpClient } from '@connectors/HttpClient'

import type { FeatureFlag } from '../types'

export const FeatureFlagService = {
    list: async (): Promise<FeatureFlag[]> => {
        const response = await httpClient.axios.get('/admin/feature-flags')
        return response.data
    },
    get: async (id: string): Promise<any> => {
        const response = await httpClient.axios.get(`/admin/feature-flags/${id}`)
        return response.data
    },
    create: async (params: Partial<FeatureFlag>): Promise<any> => {
        const response = await httpClient.axios.post('/admin/feature-flags', params)
        return response.data
    },
    delete: async (id: string): Promise<any> => {
        const response = await httpClient.axios.delete(`/admin/feature-flags/${id}`)
        return response.data
    },
    addUser: async (id: string, email: string): Promise<any> => {
        const response = await httpClient.axios.post(`/admin/feature-flags/${id}/users`, { email })
        return response.data
    },
    removeUser: async (id: string, userId: string): Promise<any> => {
        const response = await httpClient.axios.delete(`/admin/feature-flags/${id}/users`, {
            data: { userId }
        })
        return response.data
    }
}
